import {ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation} from "@angular/core";
import {AuthenticationService} from "../shared/authentication.service";
import {Router} from "@angular/router";

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  selector: 'login',
  styles: [ require('./login.component.css') ],
  template: require('./login.component.html')
})
export class LoginComponent implements OnInit {

  errorMessage: string;

  userData: { username: string, password: string };

  ngOnInit(): void {
    this.userData = {
      username : "",
      password : ""
    };
  }

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ){}

  login(){
    this.authenticationService.login(this.userData.username,this.userData.password)
      .subscribe(result => {

        if(result == true){
          //login successful
          this.router.navigateByUrl('/administration/home');
        } else {
          this.errorMessage = 'Невалидно потребителско име или парола';
        }

      });
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/+login/login.component.ts